// Per-route PWA identity for a multi-PWA SPA.
// iOS "Add to Home Screen" reads apple-touch-icon (PNG only) + apple-mobile-web-app-title
// from the LIVE DOM, not just the static index.html — so we set them per app on mount.

function ensure(selector, create) {
  let el = document.head.querySelector(selector);
  if (!el) {
    el = create();
    document.head.appendChild(el);
  }
  return el;
}

function setMeta(name, content) {
  const el = ensure(`meta[name="${name}"]`, () => {
    const m = document.createElement("meta");
    m.setAttribute("name", name);
    return m;
  });
  el.setAttribute("content", content);
}

/**
 * @param {{manifest:string, title:string, themeColor:string, appleIcon:string}} cfg
 */
export function setPwaIdentity({ manifest, title, themeColor, appleIcon }) {
  const manifestLink = ensure('link[rel="manifest"]', () => {
    const l = document.createElement("link");
    l.setAttribute("rel", "manifest");
    return l;
  });
  manifestLink.setAttribute("href", manifest);

  const appleIconLink = ensure('link[rel="apple-touch-icon"]', () => {
    const l = document.createElement("link");
    l.setAttribute("rel", "apple-touch-icon");
    return l;
  });
  appleIconLink.setAttribute("href", appleIcon);

  setMeta("apple-mobile-web-app-capable", "yes");
  setMeta("apple-mobile-web-app-title", title);
  setMeta("apple-mobile-web-app-status-bar-style", "black-translucent");
  setMeta("theme-color", themeColor);

  document.title = title;
}
